export default {
  baseStyle: {
    field: {
      _placeholder: {
        color: 'blueGrey.400',
        fontFamily: 'Rubik',
        fontSize: '16px',
      },
    },
  },
};
